const filterType = {
    TYPE_SUBMISSION_FILTER : 1,

    TYPE_ACCOUNT_FILTER : 2,

    TYPE_TASK_FILTER : 3,

    TYPE_FORMTEMPLATE_FILTER : 4,

    TYPE_ACTIVITY_FILTER : 5,

    TYPE_DATASET_FILTER : 6,

    TYPE_RULE_FILTER : 7,

    TYPE_PRODUCT_TEMPLATE_FILTER : 8,

    TYPE_ORGANIZATION_FILTER : 9

};

angular.module('gw-um-j2js')
    .constant('filterType', filterType);